<ion-content class="ion-padding">
  <div class="d-super-social__header">
    <ion-text>
      <h1>
        Detalhes sobre o programa para moradores em vulnerabilidade
      </h1>
    </ion-text>

    <ion-icon slot="icon-only" name="close-outline" (click)="close()"></ion-icon>
  </div>

  <usucampeao-detalhes-super-social></usucampeao-detalhes-super-social>
</ion-content>